import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { IUserBase, IServerUser, IProfile } from '../../types/type';

interface UserState {
  user: IProfile;
  isAuth: boolean;
  isRefreshing: boolean;
}

const initialState: UserState = {
  user: {} as IProfile,
  isAuth: false,
  isRefreshing: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<IProfile>) => {
      state.user = action.payload;
      state.isAuth = true;
      state.isRefreshing = false;
    },
    logout: (state) => {
      state.isAuth = false;
      state.user = {} as IProfile;
      state.isRefreshing = false;
    },
    setRefreshing: (state, action: PayloadAction<boolean>) => {
      state.isRefreshing = action.payload;
    },
  },
});

export const { login, logout, setRefreshing } = userSlice.actions;

export const selectCount = (state: RootState) => state.user;

export default userSlice.reducer;
